import styled from "styled-components";
import {
  Avatar,
  AvatarProps,
} from "@sonder/ui/source/styled/components/Avatar";
import { AvatarText } from "@sonder/ui/source/styled/fragments/Avatar";

export const SingularAvatar = styled(Avatar)<AvatarProps>`
  box-sizing: content-box;
`;
export const TotalAvatar = styled(AvatarText)`
  flex: 0 0 1.42rem;
  font-size: 0.6rem;
  font-weight: bold;
  height: 1.42rem;
  width: 1.42rem;

  svg {
    margin: 0 -0.25rem;
    zoom: 0.5;
  }
`;
export const MultiAvatar = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  padding-right: 0.5rem;

  ${SingularAvatar},
  ${TotalAvatar} {
    margin-left: 0;
    margin-right: -0.5rem;
  }

  ${TotalAvatar} {
    align-self: flex-start;
    z-index: 1;
  }
`;
